<div class="lane-selector">
  <button type="button" class="lane-selector-btn" (click)="toggleDropdown($event)">
    <svg class="lane-selector-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true">
      <path d="M6.5 25V8.25L24 5.25V11.75L6.5 14.75" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="lane-selector-value">{{ selectedLane }}</span>
    <svg class="lane-selector-chevron" [class.rotated]="isOpen" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M3 5L8 10L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <div class="lane-selector-menu" *ngIf="isOpen">
    <div class="lane-selector-menu-title">Switch lane</div>
    <button
      type="button"
      class="lane-selector-option"
      *ngFor="let lane of options"
      [class.selected]="lane === selectedLane"
      (click)="selectLane(lane, $event)">
      <svg class="lane-selector-option-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M3 11V3.75L11 2.5V5.75L3 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ lane }}</span>
      <svg class="lane-selector-check" *ngIf="lane === selectedLane" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M3 7.1L5.7 9.8L11 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
